import React from 'react';
import { ContractIdentifierWithName } from './contract-identifier-with-name';
import {
  DefaultContractIdentifier,
  UnknownContractInfo,
} from './default-contract-identifier';
import { DeployContractPackageResult } from '@block-explorer/entities';
import { HashLength } from '@make-software/cspr-design';
import { AvatarProps } from '../avatar/avatar';
import { HashFontSize } from '../table-data-account-info/table-data-account-info';
import { useGetContractPackageInfo } from '../../hooks/event-store-hooks';

// TODO: MOVE TO LIB
interface ContractIdentifierProps {
  hash: string;
  withName?: boolean;
  contractPackage?: DeployContractPackageResult;
  hideContractType?: boolean;
  hashLength?: HashLength;
  avatarSize?: AvatarProps['size'];
  hashFontSize?: HashFontSize;
  loading?: boolean;
}

export const ContractIdentifier = ({
  withName = false,
  hash,
  hashLength,
  hashFontSize,
  contractPackage,
  avatarSize,
  hideContractType,
  loading,
}: ContractIdentifierProps) => {
  if (!contractPackage) {
    return (
      <UnknownContractInfo
        hash={hash}
        hashFontSize={hashFontSize}
        hashLength={hashLength}
        avatarSize={avatarSize}
      />
    );
  }

  if (withName) {
    return (
      <ContractIdentifierWithName
        contractPackage={contractPackage}
        hash={hash}
        hashLength={hashLength}
        hashFontSize={hashFontSize}
        avatarSize={avatarSize}
        loading={loading}
      />
    );
  }

  return (
    <DefaultContractIdentifier
      contractPackage={contractPackage}
      hash={hash}
      hashLength={hashLength}
      hashFontSize={hashFontSize}
      avatarSize={avatarSize}
      loading={loading}
      hideContractType={hideContractType}
    />
  );
};

// TODO: Renaming suggestion - `ContractIdentifierContainer`. The reason is that we usually using `with` to specify some
// functional like `withCsprName` or `withInfo`, but `withApi` is very generic and doesn't bring specificity.
// So to align with our other components, better to rename it to suggested variant.
export const ContractIdentifierWithApi = (props) => {
  const { data: contractPackageInfo } = useGetContractPackageInfo(
    !props.contractPackage && props.hash
      ? {
          contract_package_hash: props.hash,
        }
      : null
  );
  return (
    <ContractIdentifier
      {...props}
      contractPackage={props.contractPackage || contractPackageInfo?.data}
    />
  );
};
